// extracted by mini-css-extract-plugin
module.exports = {"tag":"tag_tag__2BsIJ","multiplier":"tag_multiplier__3tsw_","count":"tag_count__3ijck"};